import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  actionTypes,
  fetchBeneficiaryRequestFailure,
  fetchBeneficiaryRequestSuccess,
  fetchEntitlementRequestFailure,
  fetchEntitlementRequestSuccess,
  getBrEntitlementsActionFailure,
  getBrEntitlementsActionSuccess,
} from "./actions";
import {
  fetchEntitlementBeneficiaryListRequests,
  fetchBusinessRolerBeneficiaryListRequests,
  fetchBrEntitlementsService,
  fetchEntitlementBAORequests,
} from "./services";
import { IAction } from "../../../models/Action";

const fetchEntitlementBAORequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_ENTITLEMENT_REQUEST),
    mergeMap(() =>
      fetchEntitlementBAORequests().pipe(
        map((response: any[]) => fetchEntitlementRequestSuccess(response)),
        catchError((error: any) => of(fetchEntitlementRequestFailure(error)))
      )
    )
  );

const fetchBeneficiaryRequestRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_BENEFICIARY_REQUEST),
    mergeMap((action: IAction) => {
      const detail = action.payload;
      const { isBR } = detail;
      const request$ = isBR
        ? fetchBusinessRolerBeneficiaryListRequests(detail)
        : fetchEntitlementBeneficiaryListRequests(detail);

      return request$.pipe(
        map((response: any[]) => fetchBeneficiaryRequestSuccess(response)),
        catchError((error: any) => of(fetchBeneficiaryRequestFailure(error)))
      );
    })
  );

const fetchBrEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_BR_ENTITLEMENT_IN_REFERENCE),
    mergeMap((action: IAction) => {
      const detail = action.payload;
      const request$ = fetchBrEntitlementsService(detail);
      return request$.pipe(
        map((response: any[]) => getBrEntitlementsActionSuccess(response)),
        catchError((error: any) => of(getBrEntitlementsActionFailure(error)))
      );
    })
  );

export default [
  fetchEntitlementBAORequestsEpic,
  fetchBeneficiaryRequestRequestsEpic,
  fetchBrEntitlementsEpic,
];
